import dynamic from 'next/dynamic';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useIsLoyaltyEnabled from '~/client/hooks/user/useIsLoyaltyEnabled';

type Props = { module: LoyaltytModule };

const LoyaltyHome = dynamic(() => import('./LoyaltyHome'));

const Loyalty: FC<Props> = ({ module }) => {
  const { isVisible, isLoggedIn, isLoggedOutLinkVisible } = useLoyalty();
  if (isLoggedOutLinkVisible && module === 'sidebar-short') {
    return <LoyaltyHome module={module} isLoggedIn={isLoggedIn} />;
  }
  if (!isVisible) {
    return <div id="loyalty-disabled" />;
  }
  return <LoyaltyHome module={module} isLoggedIn={isLoggedIn} />;
};

const useLoyalty = () => {
  const isLoyaltyEnabled = useIsLoyaltyEnabled();
  const isLoggedIn = useIsLoggedIn();
  const isVisible = isLoyaltyEnabled && isLoggedIn;
  const isLoggedOutLinkVisible = isLoyaltyEnabled && !isLoggedIn;
  return { isVisible, isLoggedIn, isLoggedOutLinkVisible };
};

export default Loyalty;
